interface SectionHeadingProps {
  eyebrow: string;
  title: string;
  desc?: string;
  align?: "center" | "left";
  tone?: "light" | "dark";
}

export default function SectionHeading({
  eyebrow,
  title,
  desc,
  align = "center",
  tone = "light",
}: SectionHeadingProps) {
  const isDark = tone === "dark";
  return (
    <div
      className={`${align === "center" ? "mx-auto text-center" : "text-left"} max-w-2xl`}
    >
      <div
        className={`inline-flex items-center gap-2 text-xs font-medium uppercase tracking-widest md:text-sm ${
          isDark ? "text-accent-300" : "text-primary-600"
        }`}
      >
        <span
          className={`h-px w-6 ${isDark ? "bg-accent-400/70" : "bg-primary-400/70"}`}
        />
        <span className="font-label">{eyebrow}</span>
      </div>
      <h2
        className={`mt-4 font-heading text-2xl font-bold md:text-4xl ${
          isDark ? "text-background-50" : "text-foreground-950"
        }`}
      >
        {title}
      </h2>
      {desc ? (
        <p
          className={`mt-4 text-sm leading-relaxed md:text-base ${
            isDark ? "text-background-200" : "text-foreground-600"
          }`}
        >
          {desc}
        </p>
      ) : null}
    </div>
  );
}